import React, { useState } from 'react';
import PropTypes from 'prop-types';

const AddItineraryModal = ({ isOpen, onClose, onSubmit }) => {
  const [itinerary, setItinerary] = useState({
    flight: '',
    hotel: '',
    transport: '',
  });

  if (!isOpen) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItinerary(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!itinerary.flight || !itinerary.hotel || !itinerary.transport) {
      alert('Please fill in all itinerary details.');
      return;
    }
    onSubmit(itinerary);
    setItinerary({ flight: '', hotel: '', transport: '' }); // Reset form
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50 font-sans">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-lg w-full transform transition-all">
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Add Itinerary</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1" htmlFor="flight">Flight Details</label>
            <input
              type="text"
              id="flight"
              name="flight"
              value={itinerary.flight}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., KLM Flight KL123"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-1" htmlFor="hotel">Hotel Details</label>
            <input
              type="text"
              id="hotel"
              name="hotel"
              value={itinerary.hotel}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., Marriott Hotel"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 font-medium mb-1" htmlFor="transport">Ground Transport</label>
            <input
              type="text"
              id="transport"
              name="transport"
              value={itinerary.transport}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., Shuttle service, taxi"
              required
            />
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Add Itinerary
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

AddItineraryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddItineraryModal;